<template>
  <v-col class="pa-0">
    <div
      class="activity-detail-page"
      v-if="
        !viewingFeedback && !viewingReports && !viewingDisputes && !followingUp
      "
    >
      <v-row class="activity-toolbar ma-2">
        <v-col cols="12" md="5">
          <v-row class="mb-2" align="center">
            <v-icon class="activity-back black-color" @click="close()">
              mdi-arrow-left
            </v-icon>
            <h4 class="grey-color mx-4" style="font-weight: 500">
              Activity Overview
            </h4>
          </v-row>
        </v-col>
        <v-col cols="12" md="7" class="pa-0 mt-4 mt-md-0">
          <v-row class="activity-actions ma-0" justify="end">
            <v-col cols="12" md="3" class="pa-0">
              <v-row justify="center">
                <v-btn
                  @click="viewingFeedback = true"
                  color="#4390c0"
                  dark
                  depressed
                  class="overview-action mx-2"
                >
                  Feedback Review
                </v-btn>
              </v-row>
            </v-col>
            <v-col cols="12" md="3" class="pa-0">
              <v-row justify="center">
                <v-btn
                  @click="viewingReports = true"
                  color="#e022d1"
                  dark
                  depressed
                  class="overview-action mx-2"
                >
                  Reported Issues
                </v-btn>
              </v-row>
            </v-col>
            <v-col cols="12" md="3" class="pa-0">
              <v-row justify="center">
                <v-btn
                  @click="viewingDisputes = true"
                  color="black"
                  dark
                  depressed
                  class="overview-action mx-2"
                >
                  Disputes
                </v-btn>
              </v-row>
            </v-col>
            <v-col v-if="activity.followedUp || role == 'Admin'" cols="12" md="3" class="pa-0">
              <v-row justify="center">
                <v-btn
                  @click="followingUp = true"
                  color="#4390c0"
                  dark
                  depressed
                  class="overview-action mx-2"
                >
                  Follow Up
                </v-btn>
              </v-row>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row class="activity-content ma-2">
        <v-col cols="12" md="6">
          <v-row justify="center" class="ma-0">
            <div class="white-card overview-card pa-8 mt-4">
              <v-row class="overview-card-header ma-0 mb-2" justify="space-between" align="center">
                <h3 class="black-color fs400">Consultation Overview</h3>
                <v-icon
                  class="blue-color pointer mx-2"
                  @click="downloadInvoice()"
                >
                  mdi-download-box
                </v-icon>
                <!-- <v-btn
                  class="mx-4"
                  dark
                  rounded
                  color="lightblue"
                  @click="downloadInvoice()"
                >
                  Download
                </v-btn> -->
              </v-row>
              <v-row class="ma-0 mb-2" justify="center">
                <h4
                  v-if="
                    !activity.denied &&
                    activity.status != 'Refunded' &&
                    activity.status != 'missed'
                  "
                  style="color: green; text-transform: capitalize"
                >
                  {{ activity.status }}
                </h4>
                <h4
                  v-if="
                    (!activity.denied && activity.status == 'Refunded') ||
                    activity.status == 'missed'
                  "
                  style="color: #e022d1; text-transform: capitalize"
                >
                  {{ activity.status }}
                </h4>
                <h4 v-if="activity.denied" style="color: red">Denied</h4>
              </v-row>
              <v-row class="ma-0 my-1" justify="center">
                <v-col cols="6">
                  <p>Consultation Date:</p>
                </v-col>
                <v-col cols="6">
                  <h4>{{ activity.date }}</h4>
                </v-col>
              </v-row>
              <v-row class="ma-0 my-1" justify="center">
                <v-col cols="6">
                  <p>Consultation Time:</p>
                </v-col>
                <v-col cols="6">
                  <h4>
                    {{
                      activity.startTimeFormatted +
                      "-" +
                      activity.endTimeFormatted
                    }}
                  </h4>
                </v-col>
              </v-row>
              <v-row class="ma-0 my-1" justify="center">
                <v-col cols="6">
                  <p>Consultation Code:</p>
                </v-col>
                <v-col cols="6">
                  <h4>{{ activity.consultCode }}</h4>
                </v-col>
              </v-row>
              <v-row class="ma-0 my-1" justify="center">
                <v-col cols="6">
                  <p>Client Name:</p>
                </v-col>
                <v-col cols="6">
                  <h4 v-if="activity.client">{{ activity.clientFullName }}</h4>
                  <h4 v-else>Client not found</h4>
                </v-col>
              </v-row>
              <v-row class="ma-0 my-1" justify="center">
                <v-col cols="6">
                  <p>Client Email Address:</p>
                </v-col>
                <v-col cols="6">
                  <h4 v-if="activity.client">{{ activity.client.email }}</h4>
                  <h4 v-else>Client not found</h4>
                </v-col>
              </v-row>
              <v-row class="ma-0 my-1" justify="center">
                <v-col cols="6">
                  <p>What's wrong:</p>
                </v-col>
                <v-col cols="6">
                  <h4>{{ activity.description }}</h4>
                </v-col>
              </v-row>
              <v-row class="ma-0 my-1" justify="center">
                <v-col cols="6">
                  <p>{{ providerLabel }} Name:</p>
                </v-col>
                <v-col cols="6">
                  <h4 v-if="activity.providerFullName || activity.doctorFullName">{{ activity.providerFullName || activity.doctorFullName }}</h4>
                  <h4 v-else>{{ providerLabel }} not found</h4>
                </v-col>
              </v-row>
              <v-row class="ma-0 my-1" justify="center">
                <v-col cols="6">
                  <p>{{ providerLabel }} Email Address:</p>
                </v-col>
                <v-col cols="6">
                  <h4 v-if="activity.providerEmail || activity.doctorEmail">{{ activity.providerEmail || activity.doctorEmail }}</h4>
                  <h4 v-else>{{ providerLabel }} not found</h4>
                </v-col>
              </v-row>
              <v-row class="ma-0 my-1" justify="center">
                <v-col cols="6">
                  <p>{{ providerLabel }} Phone Number:</p>
                </v-col>
                <v-col cols="6">
                  <h4 v-if="activity.providerPhone || activity.doctorPhone">{{ activity.providerPhone || activity.doctorPhone }}</h4>
                  <h4 v-else>{{ providerLabel }} not found</h4>
                </v-col>
              </v-row>

              <v-row class="ma-0 my-1" justify="center">
                <v-col cols="6">
                  <p>{{ providerLabel }} Type:</p>
                </v-col>
                <v-col cols="6">
                  <h4 v-if="activity.providerType || activity.doctorType">{{ activity.providerType || activity.doctorType }}</h4>
                  <h4 v-else>{{ providerLabel }} not found</h4>
                </v-col>
              </v-row>
              <v-row class="ma-0 my-1" justify="center">
                <v-col cols="6">
                  <p>Consultation Location:</p>
                </v-col>
                <v-col cols="6">
                  <h4 v-if="activity.address && activity.address.placeName">
                    {{ activity.address.placeName }}
                  </h4>
                  <h4 v-else>Online</h4>
                </v-col>
              </v-row>
              <v-row class="ma-0 my-1" justify="center">
                <v-col cols="6">
                  <p>Service:</p>
                </v-col>
                <v-col cols="6">
                  <h4>{{ activity.consultType }}</h4>
                </v-col>
              </v-row>
              <v-row class="ma-0 my-1" justify="center">
                <v-col cols="6">
                  <p>Paid:</p>
                </v-col>
                <v-col cols="6">
                  <h4 v-if="activity.paid">Yes</h4>
                  <h4 v-if="!activity.paid">No</h4>
                </v-col>
              </v-row>
              <v-row v-if="activity.denied" class="ma-0 my-1" justify="center">
                <v-col cols="6">
                  <p>Denied Reason:</p>
                </v-col>
                <v-col cols="6">
                  <h4>{{ activity.deniedReason }}</h4>
                </v-col>
              </v-row>
              <v-row
                v-if="
                  activity.refundRequested &&
                  $route.path == '/refunds' &&
                  !activity.refundApproved &&
                  !activity.refundDenied
                "
                class="ma-0 my-1"
                justify="center"
              >
                <v-col cols="12" md="6">
                  <v-row justify="center" class="ma-0">
                    <v-btn
                      @click="denyingRefund = true"
                      color="black"
                      dark
                      rounded
                      class="mb-8 mx-4"
                    >
                      Decline Refund
                    </v-btn>
                  </v-row>
                </v-col>
                <v-col cols="12" md="6">
                  <v-row justify="center" class="ma-0">
                    <v-btn
                      @click="handleRefundApproval()"
                      color="#e022d1"
                      dark
                      rounded
                      class="mb-8 mx-4"
                    >
                      Approve Refund
                    </v-btn>
                  </v-row>
                </v-col>
              </v-row>
              <v-row class="ma-0 my-1" justify="center">
                <h2 v-if="activity.refundApproved" class="blue-color">
                  Refund Approved
                </h2>
                <h2 v-if="activity.refundDenied">Refund Denied</h2>
              </v-row>
            </div>
          </v-row>
        </v-col>
        <v-col
          v-if="
            activity.consultType == 'Callout' && activity.address.coordinates
          "
          cols="12"
          md="6"
        >
          <v-row class="ma-0">
            <div class="white-card overview-card pa-8 mt-4">
              <v-row justify="center" class="ma-0 my-4">
                <div
                  id="map-container"
                  style="width: 100%; height: 300px"
                  ref="mapContainerRef"
                />
              </v-row>
              <!-- <v-row v-if="activity.consultType == 'Callout'" justify="center" class="ma-0 mt-8">
                <v-col cols="6">
                  <p>Fare</p>
                  <p class="mt-2">R800</p>
                </v-col>
                <v-col cols="6">
                  <p>GP</p>
                  <p class="mt-2">Callout</p>
                </v-col>
              </v-row> -->
              <v-row
                justify="center"
                style="border-top: 2px solid lightgrey"
                class="ma-0 mt-8"
              >
                <v-row class="mt-4" justify="center">
                  <!-- <v-col cols="4">
                    <p>Trip ID</p>
                    <h4 class="mt-2">59B324</h4>
                  </v-col>
                  <v-col cols="4">
                    <p>Trip Time</p>
                    <h4 class="mt-2">30:00</h4>
                  </v-col>
                  <v-col cols="4">
                    <p>Arrival Time</p>
                    <h4 class="mt-2">18:30</h4>
                  </v-col> -->
                  <h3 class="text-center mx-8">
                    {{ activity.address.placeName }}
                  </h3>
                </v-row>
              </v-row>
            </div>
          </v-row>
        </v-col>
        <v-col cols="12" md="6">
          <div class="white-card overview-card pa-8 mt-4">
            <v-row class="overview-card-header ma-0 mb-4" justify="start" align="center">
              <h3 class="black-color fs400">Patient Overview</h3>
            </v-row>
            <v-row
              v-if="activity.patient.firstName"
              class="ma-0 my-1"
              justify="center"
            >
              <v-col cols="6">
                <p>Name:</p>
              </v-col>
              <v-col cols="6">
                <h4>{{ activity.patient.firstName }}</h4>
              </v-col>
            </v-row>
            <v-row
              v-if="activity.patient.lastName"
              class="ma-0 my-1"
              justify="center"
            >
              <v-col cols="6">
                <p>Surname:</p>
              </v-col>
              <v-col cols="6">
                <h4>{{ activity.patient.lastName }}</h4>
              </v-col>
            </v-row>
            <v-row
              v-if="activity.patient.gender"
              class="ma-0 my-1"
              justify="center"
            >
              <v-col cols="6">
                <p>Gender:</p>
              </v-col>
              <v-col cols="6">
                <h4>{{ activity.patient.gender }}</h4>
              </v-col>
            </v-row>
            <v-row
              v-if="activity.patient.height"
              class="ma-0 my-1"
              justify="center"
            >
              <v-col cols="6">
                <p>Height:</p>
              </v-col>
              <v-col cols="6">
                <h4>{{ activity.patient.height }}</h4>
              </v-col>
            </v-row>
            <v-row
              v-if="activity.patient.weight"
              class="ma-0 my-1"
              justify="center"
            >
              <v-col cols="6">
                <p>Weight:</p>
              </v-col>
              <v-col cols="6">
                <h4>{{ activity.patient.weight }}</h4>
              </v-col>
            </v-row>
            <v-row
              v-if="activity.patient.medicalConditions"
              class="ma-0 my-1"
              justify="center"
            >
              <v-col cols="6">
                <p>Medical Conditions:</p>
              </v-col>
              <v-col cols="6">
                <h4>{{ activity.patient.medicalConditions }}</h4>
              </v-col>
            </v-row>
            <v-row
              v-if="activity.patient.allergies"
              class="ma-0 my-1"
              justify="center"
            >
              <v-col cols="6">
                <p>Allergies:</p>
              </v-col>
              <v-col cols="6">
                <h4>{{ activity.patient.allergies }}</h4>
              </v-col>
            </v-row>
            <v-row
              v-if="activity.patient.medication"
              class="ma-0 my-1"
              justify="center"
            >
              <v-col cols="6">
                <p>Medication:</p>
              </v-col>
              <v-col cols="6">
                <h4>{{ activity.patient.medication }}</h4>
              </v-col>
            </v-row>
            <v-row
              v-if="activity.patient.medicalAidName"
              class="ma-0 my-1"
              justify="center"
            >
              <v-col cols="6">
                <p>Medical Aid Name:</p>
              </v-col>
              <v-col cols="6">
                <h4>{{ activity.patient.medicalAidName }}</h4>
              </v-col>
            </v-row>
            <v-row
              v-if="activity.patient.medicalAidNo"
              class="ma-0 my-1"
              justify="center"
            >
              <v-col cols="6">
                <p>Medical Aid No:</p>
              </v-col>
              <v-col cols="6">
                <h4>{{ activity.patient.medicalAidNo }}</h4>
              </v-col>
            </v-row>
            <v-row
              v-if="activity.patient.optionName"
              class="ma-0 my-1"
              justify="center"
            >
              <v-col cols="6">
                <p>Option Name:</p>
              </v-col>
              <v-col cols="6">
                <h4>{{ activity.patient.optionName }}</h4>
              </v-col>
            </v-row>
            <v-row
              v-if="activity.patient.name"
              class="ma-0 my-1"
              justify="center"
            >
              <v-col cols="6">
                <p>Name:</p>
              </v-col>
              <v-col cols="6">
                <h4>{{ activity.patient.name }}</h4>
              </v-col>
            </v-row>
            <v-row
              v-if="activity.patient.type"
              class="ma-0 my-1"
              justify="center"
            >
              <v-col cols="6">
                <p>Type:</p>
              </v-col>
              <v-col cols="6">
                <h4>{{ activity.patient.type }}</h4>
              </v-col>
            </v-row>
            <v-row
              v-if="activity.patient.breed"
              class="ma-0 my-1"
              justify="center"
            >
              <v-col cols="6">
                <p>Breed:</p>
              </v-col>
              <v-col cols="6">
                <h4>{{ activity.patient.breed }}</h4>
              </v-col>
            </v-row>
            <v-row
              v-if="activity.patient.age"
              class="ma-0 my-1"
              justify="center"
            >
              <v-col cols="6">
                <p>Age:</p>
              </v-col>
              <v-col cols="6">
                <h4>{{ activity.patient.age }}</h4>
              </v-col>
            </v-row>
            <v-row
              v-if="activity.patient.insurance"
              class="ma-0 my-1"
              justify="center"
            >
              <v-col cols="6">
                <p>Insurance:</p>
              </v-col>
              <v-col cols="6">
                <h4>{{ activity.patient.insurance }}</h4>
              </v-col>
            </v-row>
          </div>
        </v-col>
        <v-col cols="12" md="6" v-if="role == 'Super Admin'">
          <div class="white-card overview-card pa-8 mt-4">
            <v-row class="overview-card-header ma-0 mb-2" justify="start" align="center">
              <h3 class="black-color fs400">Finance Overview</h3>
            </v-row>
            <v-row class="ma-0 my-1" justify="center">
              <v-col cols="6">
                <p>Consultation Fee Paid:</p>
              </v-col>
              <v-col cols="6">
                <h4>R{{ activity.paidAmount || 0 }}</h4>
              </v-col>
            </v-row>
            <v-row class="ma-0 my-1" justify="center">
              <v-col cols="6">
                <p>Consultation Lotus Fee(25%):</p>
              </v-col>
              <v-col cols="6">
                <h4>R{{ activity.lotusFee || 0 }}</h4>
              </v-col>
            </v-row>
            <v-row class="ma-0 my-1" justify="center">
              <v-col cols="6">
                <p>Consultation Doctor Amount:</p>
              </v-col>
              <v-col cols="6">
                <h4>R{{ activity.doctorAmount || 0 }}</h4>
              </v-col>
            </v-row>
            <v-row class="ma-0 my-1" justify="center">
              <v-col cols="6">
                <p>Total Additional Costs:</p>
              </v-col>
              <v-col cols="6">
                <h4>R{{ activity.totalAdditionalAmount || 0 }}</h4>
              </v-col>
            </v-row>
            <v-row class="ma-0 my-1" justify="center">
              <v-col cols="6">
                <p>Total Additional Lotus Fee(25%):</p>
              </v-col>
              <v-col cols="6">
                <h4>R{{ activity.lotusAdditionalFee || 0 }}</h4>
              </v-col>
            </v-row>
            <v-row class="ma-0 my-1" justify="center">
              <v-col cols="6">
                <p>Total Additional Doctor Amount:</p>
              </v-col>
              <v-col cols="6">
                <h4>R{{ activity.doctorAdditionalAmount || 0 }}</h4>
              </v-col>
            </v-row>
            <v-row class="overview-card-header ma-0 mb-2 mt-6" justify="start" align="center">
              <h3 class="black-color fs400">Additional Charges</h3>
            </v-row>
            <v-col class="pa-0 chargesHolder">
              <v-row
                v-if="activity.totalAdditionalAmount == 0"
                justify="start"
                class="ma-0"
              >
                <h4 style="color: #4390c0">No additional charges...</h4>
              </v-row>
              <v-row
                v-for="charge in activity.additionalCharges"
                :key="charge"
                justify="start"
                class="ma-0"
              >
                <h4>
                  {{
                    "- " +
                    charge.quantity +
                    "x " +
                    charge.description +
                    " R" +
                    charge.amount
                  }}
                </h4>
                <h4 style="color: green" v-if="charge.paid">(Paid)</h4>
                <h4 style="color: green" v-if="charge.approved && !charge.paid">
                  (Approved)
                </h4>
                <h4 style="color: red" v-if="charge.denied && !charge.approved">
                  (Denied)
                </h4>
              </v-row>
            </v-col>
          </div>
        </v-col>
        <v-col v-if="activity.patientRating" cols="12" md="6">
          <v-row justify="center" class="ma-0">
            <div class="white-card overview-card pa-8 mt-4">
              <v-row justify="center" class="ma-0">
                <h3 class="black-color fs400">Client Rating</h3>
              </v-row>
              <v-row justify="center" class="ma-0 mt-2">
                <v-icon style="color: yellow" x-large>mdi-star</v-icon>
                <h2 class="fs400 mx-1 mt-1">
                  {{ activity.patientRating }} Star(s)
                </h2>
              </v-row>
            </div>
          </v-row>
        </v-col>
        <v-col v-if="activity.doctorRating" cols="12" md="6">
          <v-row justify="center" class="ma-0">
            <div class="white-card overview-card pa-8 mt-4">
              <v-row justify="center" class="ma-0">
                <h3 class="black-color fs400">Doctor Rating</h3>
              </v-row>
              <v-row justify="center" class="ma-0 mt-2">
                <v-icon style="color: yellow" x-large>mdi-star</v-icon>
                <h2 class="fs400 mx-1 mt-1">
                  {{ activity.doctorRating }} Star(s)
                </h2>
              </v-row>
            </div>
          </v-row>
        </v-col>
      </v-row>
    </div>
    <div v-if="viewingFeedback">
      <v-col>
        <v-row justify="center">
          <v-row class="ma-2">
            <v-col cols="12" md="6">
              <v-row class="mb-2">
                <v-icon class="activity-back black-color" @click="close()">
                  mdi-arrow-left
                </v-icon>
                <h4 class="grey-color mx-4" style="font-weight: 500">
                  Activity Overview
                </h4>
              </v-row>
            </v-col>
            <!-- <v-col cols="12" md="6" class="pa-0">
              <v-row justify-md="end" justify="center">
                <v-btn @click="$router.push('/home')" color="#e022d1" dark rounded width="240px" class="mb-8 mx-4">
                  Request More Info
                </v-btn>
              </v-row>
            </v-col> -->
          </v-row>
        </v-row>
        <v-row justify="center">
          <div class="white-card">
            <v-col class="pa-8">
              <v-row class="ma-0">
                <v-col cols="12" md="6">
                  <v-row class="mb-6" justify="start">
                    <v-icon
                      class="black-color"
                      @click="
                        viewingFeedback = false;
                        initializeMap();
                      "
                    >
                      mdi-arrow-left
                    </v-icon>
                    <h2 class="fs400 mx-4">Feedback from Doctor</h2>
                  </v-row>
                  <v-row justify="start">
                    <v-col cols="6" md="6">
                      <v-row>
                        <p>Diagnosis Confirmation:</p>
                      </v-row>
                    </v-col>
                    <v-col cols="6" md="6">
                      <v-row>
                        <h4 class="blue-color">
                          {{ activity.diagnosis || "No diagnosis available" }}
                        </h4>
                      </v-row>
                    </v-col>
                  </v-row>
                  <v-row style="margin-top: 100px" justify="start">
                    <v-col cols="6" md="6">
                      <v-row>
                        <p>Treatment Plan:</p>
                      </v-row>
                    </v-col>
                    <v-col cols="6" md="6">
                      <v-row>
                        <v-col cols="12" class="pa-0">
                          <h4 class="blue-color">
                            {{
                              activity.treatmentPlan ||
                              "No treatment plan available"
                            }}
                          </h4>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                  <v-row style="margin-top: 100px" class="mb-6" justify="start">
                    <v-col cols="6" md="6">
                      <v-row>
                        <p>Medication:</p>
                      </v-row>
                    </v-col>
                    <v-col cols="6" md="6">
                      <v-row>
                        <v-col cols="12" class="pa-0">
                          <h4 class="blue-color">
                            {{
                              activity.prescription ||
                              "No prescription available"
                            }}
                          </h4>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                  <!-- <v-row
                    v-show="
                      activity.videoRecordings && activity.videoRecordings[0]
                    "
                    justify="start"
                  >
                    <v-col>
                      <v-row justify="start">
                        <h2 class="fs400 mb-6">Video Recordings</h2>
                      </v-row>
                      <v-row justify="center">
                        <v-col class="files-holder pa-0">
                          <v-row
                            v-for="video in activity.videoRecordings"
                            :key="video"
                            class="ma-0 mb-2"
                          >
                            <v-col class="pa-0">
                              <v-row justify="center" class="ma-0 pointer">
                                <v-col class="pa-0" cols="1">
                                  <h3>-</h3>
                                </v-col>
                                <v-col class="pa-0" cols="11">
                                  <h3
                                    class="blue-color"
                                    @click="openWindow(video.url)"
                                  >
                                    {{ video.name }}
                                  </h3>
                                </v-col>
                              </v-row>
                            </v-col>
                          </v-row>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                  <v-row
                    v-show="
                      activity.voiceRecordings && activity.voiceRecordings[0]
                    "
                    justify="start"
                  >
                    <v-col>
                      <v-row justify="start">
                        <h2 class="fs400 mb-6">Voice Recordings</h2>
                      </v-row>
                      <v-row justify="center">
                        <v-col class="files-holder pa-0">
                          <v-row
                            v-for="voice in activity.voiceRecordings"
                            :key="voice"
                            class="ma-0 mb-2"
                          >
                            <v-col class="pa-0">
                              <v-row justify="center" class="ma-0 pointer">
                                <v-col class="pa-0" cols="1">
                                  <h3>-</h3>
                                </v-col>
                                <v-col class="pa-0" cols="11">
                                  <h3
                                    class="blue-color"
                                    @click="openWindow(voice.url)"
                                  >
                                    {{ voice.name }}
                                  </h3>
                                </v-col>
                              </v-row>
                            </v-col>
                          </v-row>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row> -->
                  <v-col
                    v-show="activity.notes && activity.notes[0]"
                    class="reportsHolder"
                  >
                    <v-row justify="start">
                      <h2 class="fs400 mb-6">Consultation Notes</h2>
                    </v-row>
                    <v-row
                      v-for="note in activity.notes"
                      :key="note"
                      justify="start"
                      class="ma-0 mb-4"
                    >
                      <v-card
                        class="pa-2"
                        style="border-radius: 25px"
                        color="#4390c0"
                      >
                        <v-row class="ma-0">
                          <h4 class="white-color">{{ note }}</h4>
                        </v-row>
                      </v-card>
                    </v-row>
                  </v-col>
                </v-col>
                <v-col cols="12" md="6">
                  <v-row justify="start" v-if="role == 'Super Admin'">
                    <h2 class="fs400 mb-6">Consultation Documents</h2>
                  </v-row>
                  <v-row justify="start" v-if="role == 'Super Admin'">
                    <v-col class="files-holder pa-0">
                      <v-row
                        v-for="file in activity.medicalDocumentation"
                        :key="file"
                        class="ma-0 mb-2"
                      >
                        <v-col class="pa-0">
                          <v-row justify="center" class="ma-0 pointer">
                            <v-col class="pa-0" cols="1">
                              <h3>-</h3>
                            </v-col>
                            <v-col class="pa-0" cols="11">
                              <h3
                                class="blue-color"
                                @click="openWindow(file.downloadURL)"
                              >
                                {{ file.type }}
                              </h3>
                            </v-col>
                          </v-row>
                        </v-col>
                      </v-row>
                      <v-row
                        v-if="
                          !activity.medicalDocumentation ||
                          !activity.medicalDocumentation[0]
                        "
                        class="ma-0 pb-2"
                      >
                        <v-col class="pa-0">
                          <h3 class="blue-color">
                            No documentation uploaded yet...
                          </h3>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                  <v-row justify="start">
                    <h2 class="fs400 mb-6">Consultation Files</h2>
                  </v-row>
                  <v-row justify="start">
                    <v-col class="files-holder pa-0">
                      <v-row
                        v-for="file in activity.files"
                        :key="file"
                        class="ma-0 mb-2"
                      >
                        <v-col class="pa-0">
                          <v-row justify="center" class="ma-0 pointer">
                            <v-col class="pa-0" cols="1">
                              <h3>-</h3>
                            </v-col>
                            <v-col class="pa-0" cols="11">
                              <h3
                                class="blue-color"
                                @click="openWindow(file.url)"
                              >
                                {{ file.name }}
                              </h3>
                            </v-col>
                          </v-row>
                        </v-col>
                      </v-row>
                      <v-row
                        v-if="!activity.files || !activity.files[0]"
                        class="ma-0 pb-2"
                      >
                        <v-col class="pa-0">
                          <h3 class="blue-color">No files uploaded yet...</h3>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-col>
          </div>
        </v-row>
      </v-col>
    </div>
    <div v-if="viewingReports">
      <v-row justify="center" class="ma-0">
        <div class="white-card pa-8">
          <v-row class="ma-0 mt-0 mb-2">
            <v-icon
              class="black-color"
              @click="
                viewingReports = false;
                initializeMap();
              "
            >
              mdi-arrow-left
            </v-icon>
            <h4 class="grey-color mx-4" style="font-weight: 500">
              Activity Reports
            </h4>
          </v-row>
          <v-col class="reportsHolder">
            <v-row
              v-for="report in sortedReports"
              :key="report"
              justify="center"
              class="ma-0 mb-4"
            >
              <v-card
                class="pa-4"
                width="100%"
                style="border-radius: 25px"
                color="#4390c0"
              >
                <v-row class="ma-0">
                  <h3 class="white-color">{{ report.reason }}</h3>
                </v-row>
                <v-row class="ma-0">
                  <h4 class="white-color">{{ report.message }}</h4>
                </v-row>
                <v-row class="ma-0">
                  <h5 class="white-color">{{ report.date }}</h5>
                </v-row>
              </v-card>
            </v-row>
            <v-row
              v-if="!sortedReports || !sortedReports[0]"
              justify="start"
              class="ma-0 mb-4"
            >
              <h2 class="blue-color">No reported issues yet...</h2>
            </v-row>
          </v-col>
        </div>
      </v-row>
    </div>
    <div v-if="viewingDisputes">
      <v-row justify="center" class="ma-0">
        <div class="white-card pa-8">
          <v-row class="ma-0 mt-0 mb-2">
            <v-icon
              class="black-color"
              @click="
                viewingDisputes = false;
                initializeMap();
              "
            >
              mdi-arrow-left
            </v-icon>
            <h4 class="grey-color mx-4" style="font-weight: 500">
              Activity Disputes
            </h4>
          </v-row>
          <v-row justify="center" class="ma-0">
            <v-col cols="12" md="6" class="reportsHolder px-8 mb-6">
              <v-row
                v-for="(dispute, index) in sortedDisputes"
                :key="index"
                justify="center"
                class="ma-0 mb-4"
              >
                <v-card
                  :class="{
                    patientDispute: dispute.userType == 'Patient',
                    adminDispute: dispute.userType == 'Admin',
                  }"
                  class="pa-4"
                  width="100%"
                  style="border-radius: 25px"
                  color="#4390c0"
                >
                  <v-row class="ma-0">
                    <h4 class="white-color">{{ dispute.message }}</h4>
                  </v-row>
                  <v-row
                    class="ma-0 my-3"
                    v-if="dispute.doctorName && dispute.userType == 'Doctor'"
                  >
                    <h4 class="white-color">{{ dispute.doctorName }}</h4>
                  </v-row>

                  <v-row
                    class="ma-0 my-3"
                    v-if="
                      activity.clientFullName && dispute.userType == 'Patient'
                    "
                  >
                    <h4 class="white-color">{{ activity.clientFullName }}</h4>
                  </v-row>
                  <v-row class="ma-0 my-3" v-if="dispute.admin">
                    <h4 class="white-color">
                      {{ dispute.admin.name + " " + dispute.admin.surname }}
                    </h4>
                  </v-row>
                  <v-row class="ma-0">
                    <h5 class="white-color">{{ dispute.date }}</h5>
                  </v-row>
                  <v-row class="ma-0">
                    <h5 class="white-color">{{ dispute.time }}</h5>
                  </v-row>
                </v-card>
              </v-row>
              <v-row
                v-if="!activity.disputes || !activity.disputes[0]"
                justify="start"
                class="ma-0 mb-4"
              >
                <h2 class="blue-color">No disputes yet...</h2>
              </v-row>
            </v-col>
            <v-col cols="12" md="6" class="px-8">
              <v-row justify="center" justify-md="start">
                <h3>Add Feedback</h3>
              </v-row>
              <v-row class="ma-0 mt-4" justify="center">
                <v-select
                  v-model="feedbackRecipient"
                  :items="['Doctor', 'Patient']"
                  label="Responding To"
                  outlined
                  dense
                  required
                  :rules="[(v) => !!v || 'Select a recipient']"
                ></v-select>
              </v-row>
              <v-row justify="center">
                <v-form ref="disputeForm" style="width: 100%">
                  <v-row class="ma-0 mt-2" justify="center">
                    <v-textarea
                      required
                      :rules="nullRules"
                      label="Message"
                      outlined
                      dense
                      filled
                      v-model="disputeMessage"
                    >
                    </v-textarea>
                  </v-row>
                </v-form>
              </v-row>
              <v-row justify="center" justify-md="start">
                <v-btn
                  @click="addDispute()"
                  color="#4390c0"
                  dark
                  rounded
                  width="240px"
                  class="mt-6"
                >
                  Add Feedback
                </v-btn>
              </v-row>
            </v-col>
          </v-row>
        </div>
      </v-row>
    </div>
    <div v-if="followingUp">
      <v-row justify="center" class="ma-0">
        <div class="white-card pa-8">
          <v-row class="ma-0 mt-0 mb-6">
            <v-icon
              class="black-color"
              @click="
                followingUp = false;
                initializeMap();
              "
            >
              mdi-arrow-left
            </v-icon>
            <h4 class="grey-color mx-4" style="font-weight: 500">
              Consultation Follow Up
            </h4>
          </v-row>
          <v-row
              v-if="activity.followedUpBy"
              justify="start"
              class="ma-0"
            >
              <h4 class="fs400 mb-4">Followed up by:</h4>
              <h4 class="blue-color mb-4">{{ activity.followedUpBy }}</h4>
            </v-row>
          <v-form ref="followUpForm">
            <v-row justify="start" class="ma-0">
              <v-col cols="6">
                <v-row justify="start" class="ma-0">
                  <h3>
                    1. Were you satisfied with the care and service you received
                    during your consultation?
                  </h3>
                </v-row>
                <v-row justify="start" class="ma-0">
                  <v-radio-group
                    :readonly="role != 'Admin' || activity.followedUp"
                    v-model="followUp.clientSatisfied"
                    required
                    :rules="nullRules"
                    row
                    class="mt-0"
                  >
                    <v-radio label="Yes" value="Yes"> </v-radio>
                    <v-radio label="No" value="No"> </v-radio>
                  </v-radio-group>
                </v-row>
              </v-col>
              <v-col cols="6">
                <v-row justify="start" class="ma-0">
                  <h3>
                    2. Have your symptoms or concerns improved since the
                    consultation?
                  </h3>
                </v-row>
                <v-row justify="start" class="ma-0">
                  <v-select
                    :readonly="role != 'Admin' || activity.followedUp"
                    v-model="followUp.clientImprovements"
                    :items="[
                      'Yes, significantly',
                      'Yes, Slightly',
                      'No Change',
                      'It has gotten worse',
                    ]"
                    style="max-width: 240px"
                    outlined
                    dense
                    filled
                    required
                    :rules="nullRules"
                  >
                  </v-select>
                </v-row>
                <v-row justify="start" class="ma-0">
                  <v-textarea
                    :readonly="role != 'Admin' || activity.followedUp"
                    v-model="followUp.clientImprovementsComments"
                    label="Comments"
                    filled
                    dense
                    outlined
                  >
                  </v-textarea>
                </v-row>
              </v-col>
              <v-col cols="6">
                <v-row justify="start" class="ma-0">
                  <h3>
                    3. Did the practitioner provide clear instructions or next
                    steps (medication, follow-up visits, tests, etc.)?
                  </h3>
                </v-row>
                <v-row justify="start" class="ma-0">
                  <v-radio-group
                    :readonly="role != 'Admin' || activity.followedUp"
                    v-model="followUp.doctorClearInstructions"
                    required
                    :rules="nullRules"
                    row
                    class="mt-0"
                  >
                    <v-radio label="Yes" value="Yes"> </v-radio>
                    <v-radio label="No" value="No"> </v-radio>
                  </v-radio-group>
                </v-row>
                <v-row justify="start" class="ma-0">
                  <v-textarea
                    :readonly="role != 'Admin' || activity.followedUp"
                    v-model="followUp.doctorClearInstructionsComments"
                    label="Comments"
                    filled
                    dense
                    outlined
                  >
                  </v-textarea>
                </v-row>
              </v-col>
              <v-col cols="6">
                <v-row justify="start" class="ma-0">
                  <h3>
                    4. How would you rate your overall experience using the
                    Lotus Life App? (1,2,3,4,5) - (1=Very Poor / 5 = Excellent)
                  </h3>
                </v-row>
                <v-row justify="start" class="ma-0">
                  <v-select
                    :readonly="role != 'Admin' || activity.followedUp"
                    v-model="followUp.lotusRating"
                    required
                    :rules="nullRules"
                    :items="[1, 2, 3, 4, 5]"
                    style="max-width: 240px"
                    outlined
                    dense
                    filled
                  >
                  </v-select>
                </v-row>
              </v-col>
              <v-col cols="6">
                <v-row justify="start" class="ma-0">
                  <h3>5. Follow-Up Required</h3>
                </v-row>
                <v-row justify="start" class="ma-0">
                  <v-select
                    :readonly="role != 'Admin' || activity.followedUp"
                    v-model="followUp.followUpRequired"
                    required
                    :rules="nullRules"
                    :items="[
                      'No Further Action Required',
                      'Practitioner follow-up needed',
                      'Escalate to medical team',
                      'Escalate to customer service manager',
                      'Technical issue reported (App/Platform)',
                    ]"
                    style="max-width: 240px"
                    outlined
                    dense
                    filled
                  >
                  </v-select>
                </v-row>
                <v-row justify="start" class="ma-0">
                  <v-textarea
                    :readonly="role != 'Admin' || activity.followedUp"
                    v-model="followUp.followUpRequiredComments"
                    label="Comments"
                    filled
                    dense
                    outlined
                  >
                  </v-textarea>
                </v-row>
              </v-col>
            </v-row>
            <v-row
              v-if="role == 'Admin' && !activity.followedUp"
              class="ma-0"
              justify="center"
              justify-md="start"
            >
              <v-btn
                @click="submitFollowUp()"
                color="#4390c0"
                dark
                rounded
                class="mx-4"
              >
                Submit
              </v-btn>
            </v-row>
          </v-form>
        </div>
      </v-row>
    </div>
    <v-dialog v-model="promptDialog" max-width="480">
      <v-card class="pa-8" elevation="4" shaped style="border-radius: 24px">
        <v-card-text class="text-center">
          <v-icon size="96" color="red" v-if="promptType == 'error'">
            mdi-alert-circle
          </v-icon>
          <v-icon size="96" color="green" v-if="promptType == 'success'">
            mdi-check-circle
          </v-icon>
          <div class="text-h5 my-6" v-if="promptType == 'error'">Error</div>
          <div class="text-h5 my-6" v-if="promptType == 'success'">Success</div>
          <div class="body-1 text-h6">{{ promptMessage }}</div>
        </v-card-text>
        <v-card-actions class="justify-center">
          <v-btn
            color="black"
            dark
            depressed
            large
            style="border-radius: 24px"
            @click="promptDialog = false"
          >
            CLOSE
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="denyingRefund" max-width="480">
      <div class="white-card pa-8">
        <v-row justify="center">
          <h3 class="text-center">
            Are you sure you want to deny this refund request?
          </h3>
        </v-row>
        <v-row justify="center" class="ma-0">
          <v-btn
            @click="denyRefund()"
            rounded
            dark
            class="mt-8"
            color="#e022d1"
            width="200px"
          >
            YES
          </v-btn>
        </v-row>
        <v-row justify="center" class="ma-0">
          <v-btn
            rounded
            dark
            class="mt-4"
            color="#4390c0"
            @click="denyingRefund = false"
            width="200px"
          >
            NO
          </v-btn>
        </v-row>
      </div>
    </v-dialog>
  </v-col>
</template>

<script>
import {
  collection,
  getDocs,
  where,
  getFirestore,
  setDoc,
  query,
  getDoc,
  doc,
  updateDoc,
  addDoc,
  deleteDoc,
} from "firebase/firestore";
import { firebaseApp } from "../../firebaseConfig.js";
const db = getFirestore(firebaseApp);

import mapboxgl from "mapbox-gl";
import "mapbox-gl/dist/mapbox-gl.css";

import { PDFDocument, rgb, StandardFonts } from "pdf-lib";

import logo from "../assets/images/logo.png";

export default {
  data() {
    return {
      feedbackRecipient: "",
      doctorName: "",
      viewingFeedback: false,
      viewingReports: false,
      viewingDisputes: false,
      mapContainer: null,
      map: null,
      markers: [],
      MARKER_SIZE_PX: 44,
      BRAND_BLUE: "#4390c0",
      MAPBOX_TOKEN:
        "pk.eyJ1IjoibWVkaWNhcmUxMjMiLCJhIjoiY21nNHd5aHd5MDV3YTJrczRldDAzb2FrNCJ9.hv4_cvftMn5j2ENwzROWKg",
      disputeMessage: "",
      nullRules: [(v) => !!v || "Field is required"],
      promptDialog: false,
      promptMessage: "",
      promptType: "",
      merchantId: "10040492",
      merchantKey: "ny33hkarlf0k9",
      amount: 100,
      paymentCode: null,
      code: null,
      denyingRefund: false,
      logo: logo,
      followingUp: false,
      followUp: {},
      nullRules: [(v) => !!v || "Field is required"],
    };
  },
  props: {
    activity: Object,
  },
  created() {
    if (this.activity.reportedIssues && this.activity.reportedIssues[0]) {
      for (let i = 0; i < this.activity.reportedIssues.length; i++) {
        const report = this.activity.reportedIssues[i];
        report.date = new Date(report.dateCreated.seconds * 1000)
          .toISOString()
          .substring(0, 10);
      }
    }

    if (this.activity.disputes) {
      for (let i = 0; i < this.activity.disputes.length; i++) {
        const dispute = this.activity.disputes[i];
        if (dispute) {
          dispute.date = new Date(dispute.dateCreated.seconds * 1000)
            .toISOString()
            .substring(0, 10);
          dispute.time = new Date(
            dispute.dateCreated.seconds * 1000
          ).toLocaleTimeString();
        }
      }
    }

    this.$forceUpdate();

    setTimeout(() => {
      if (this.$route.query.success && this.$route.query.paymentCode) {
        if (this.$route.query.paymentCode == this.activity.id) {
          this.markRefundAsApproved();
        }
      }
    }, 1000);

    localStorage.setItem("ViewedActivity", JSON.stringify(this.activity));

    if (this.activity.followedUp) {
      this.followUp = { ...this.activity };
    }
  },
  async mounted() {
    const providerID =
      this.activity.doctorID ||
      this.activity.nurseID ||
      this.activity.ambulanceID ||
      this.activity.providerID ||
      this.activity.businessID;

    if (providerID) {
      const providerCollections = this.activity.ambulanceID
        ? ["businesses", "doctors"]
        : ["doctors", "businesses"];
      let provider = null;

      for (const providerCollection of providerCollections) {
        const providerRef = doc(db, providerCollection, providerID);
        const providerSnap = await getDoc(providerRef);

        if (providerSnap.exists()) {
          provider = { ...providerSnap.data(), id: providerSnap.id };
          break;
        }
      }

      if (provider) {
        const providerName =
          provider.companyName ||
          `${provider.name || ""} ${provider.surname || ""}`.trim() ||
          `${provider.firstName || ""} ${provider.lastName || ""}`.trim() ||
          "Provider not found";
        const profession = Array.isArray(provider.profession)
          ? provider.profession.join(", ")
          : provider.profession;

        this.activity.provider = provider;
        this.activity.doctor = provider;
        this.activity.providerFullName = providerName;
        this.activity.doctorFullName = providerName;
        this.activity.providerEmail = provider.email || "N/A";
        this.activity.doctorEmail = provider.email || "N/A";
        this.activity.providerPhone = provider.CellNo || provider.contact || "N/A";
        this.activity.doctorPhone = provider.CellNo || provider.contact || "N/A";
        this.activity.providerType = this.activity.providerType || profession || this.providerLabel;
        this.activity.doctorType = this.activity.providerType;
      } else {
        this.activity.providerFullName = this.activity.providerFullName || `${this.providerLabel} not found`;
        this.activity.doctorFullName = this.activity.doctorFullName || this.activity.providerFullName;
        this.activity.providerEmail = this.activity.providerEmail || "N/A";
        this.activity.doctorEmail = this.activity.doctorEmail || "N/A";
        this.activity.providerPhone = this.activity.providerPhone || "N/A";
        this.activity.doctorPhone = this.activity.doctorPhone || "N/A";
        this.activity.providerType = this.activity.providerType || this.providerLabel;
        this.activity.doctorType = this.activity.doctorType || this.activity.providerType;
      }

      if (this.activity.disputes) {
        this.activity.disputes.forEach((dispute) => {
          if (dispute.userType == "Doctor") {
            dispute.doctorName = this.activity.providerFullName || this.activity.doctorFullName;
          } else if (dispute.userType == "Patient") {
            dispute.userType == "Doctor";
          }
          if (dispute.dateCreated?.seconds) {
            dispute.date = new Date(dispute.dateCreated.seconds * 1000)
              .toISOString()
              .substring(0, 10);
            dispute.time = new Date(
              dispute.dateCreated.seconds * 1000
            ).toLocaleTimeString();
          }
          this.$forceUpdate();
        });
      }

      this.doctorName = this.activity.providerFullName || this.activity.doctorFullName;
      this.$forceUpdate();
    }
    // Initialize map if Callout
    if (this.activity.consultType === "Callout") {
      mapboxgl.accessToken = this.MAPBOX_TOKEN;
      this.initializeMap();
    }
  },
  beforeUnmount() {
    try {
      this.map?.remove();
    } catch {}
  },
  methods: {
    handleRefundApproval() {
      if (this.activity.paid) {
        this.redirectToPayFast();
      } else {
        this.markRefundAsApproved();
      }
    },
    async markRefundAsApproved() {
      try {
        this.loading = true;
        const docRef = await updateDoc(
          doc(db, "consultations", this.activity.id),
          {
            refundApproved: true,
            status: "Refunded",
          }
        );
        this.loading = false;

        this.addNotification(
          this.activity.doctorID,
          "Doctor",
          "Refund Request Approved",
          "A refund request for your consultation on " +
            this.activity.date +
            " at " +
            this.activity.startTime +
            " has been approved!"
        );
        this.addNotification(
          this.activity.clientID,
          "Client",
          "Refund Request Approved",
          "A refund request for your consultation on " +
            this.activity.date +
            " at " +
            this.activity.startTime +
            " has been approved!"
        );

        this.$router.replace("/refunds");

        this.activity.refundApproved = true;
        this.activity.status = "Refunded";

        localStorage.setItem("ViewedActivity", JSON.stringify(this.activity));

        this.promptMessage = "Successfully approved refund request!";
        this.promptType = "success";
        this.promptDialog = true;
      } catch (error) {
        this.loading = false;
        console.log(error);

        this.promptMessage =
          "Something went wrong with approving the refund request, please try again!";
        this.promptType = "error";
        this.promptDialog = true;
      }
    },
    async denyRefund() {
      this.denyingRefund = false;

      try {
        this.loading = true;
        const docRef = await updateDoc(
          doc(db, "consultations", this.activity.id),
          {
            refundDenied: true,
          }
        );
        this.loading = false;

        this.addNotification(
          this.activity.clientID,
          "Client",
          "Refund Request Denied",
          "A refund request for your consultation on " +
            this.activity.date +
            " at " +
            this.activity.startTime +
            " has been denied!"
        );

        this.activity.refundDenied = true;

        localStorage.setItem("ViewedActivity", JSON.stringify(this.activity));

        this.promptMessage = "Successfully denied refund request!";
        this.promptType = "success";
        this.promptDialog = true;
      } catch (error) {
        this.loading = false;
        console.log(error);

        this.promptMessage =
          "Something went wrong with approving the refund request, please try again!";
        this.promptType = "error";
        this.promptDialog = true;
      }
    },
    close() {
      this.$emit("close");
    },
    openWindow(url) {
      window.open(url, "_blank");
    },
    async initializeMap() {
      setTimeout(() => {
        if (this.activity.consultType == "Callout") {
          try {
            this.map?.remove();
          } catch {}

          if (this.activity.address.coordinates) {
            this.map = new mapboxgl.Map({
              container: this.$refs.mapContainerRef,
              style: "mapbox://styles/mapbox/light-v11",
              center: [
                this.activity.address.coordinates.longitude,
                this.activity.address.coordinates.latitude,
              ],
              zoom: 14,
            });

            new mapboxgl.Marker()
              .setLngLat([
                this.activity.address.coordinates.longitude,
                this.activity.address.coordinates.latitude,
              ]) // [longitude, latitude]
              .addTo(this.map);
          }
        }
      }, 500);
    },
    async addDispute() {
      let valid = this.$refs.disputeForm.validate();

      if (!valid) {
        this.promptMessage = "Please fill out all required fields!";
        this.promptType = "error";
        this.promptDialog = true;
        return;
      }

      if (!this.feedbackRecipient) {
        this.promptMessage = "Please select who you are responding to!";
        this.promptType = "error";
        this.promptDialog = true;
        return;
      }

      try {
        if (!this.activity.disputes) {
          this.activity.disputes = [];
        }

        let newDispute = {
          message: this.disputeMessage,
          dateCreated: new Date(),
          recipientType: this.feedbackRecipient,
          userID: this.$store.state.user.id,
          admin: this.$store.state.user,
        };

        newDispute.date = new Date().toISOString().substring(0, 10);
        newDispute.time = new Date().toLocaleTimeString();

        this.activity.disputes.push(newDispute);

        this.loading = true;
        await updateDoc(doc(db, "consultations", this.activity.id), {
          disputes: this.activity.disputes,
        });
        this.loading = false;

        localStorage.setItem("ViewedActivity", JSON.stringify(this.activity));

        this.disputeMessage = "";
        this.feedbackRecipient = ""; // reset select

        this.promptMessage = "Successfully submitted feedback!";
        this.promptType = "success";
        this.promptDialog = true;
      } catch (error) {
        this.loading = false;
        console.log(error);

        this.promptMessage =
          "Something went wrong with submitting the feedback, please try again!";
        this.promptType = "error";
        this.promptDialog = true;
      }
    },
    redirectToPayFast() {
      this.amount = 500;

      const form = document.createElement("form");
      form.method = "POST";
      form.action = "https://sandbox.payfast.co.za/eng/process"; // no leading space/tab
      const returnUrlWithAmount = `${window.location.origin}/refunds?paymentCode=${this.activity.id}&success=${this.amount}`;
      form.innerHTML = `
          <input type="hidden" name="merchant_id" value="${this.merchantId}" />
          <input type="hidden" name="merchant_key" value="${this.merchantKey}" />
          <input type="hidden" name="amount" value="${this.amount}" />
          <input type="hidden" name="item_name" value="Consultation Refund for ${this.amount}" />
          <input type="hidden" name="return_url" value="${returnUrlWithAmount}" />
          <input type="hidden" name="cancel_url" value="${window.location.origin}/refunds" />
        `;
      document.body.appendChild(form);
      form.submit();
    },
    async addNotification(userID, userType, type, message) {
      let notification = {
        createdAt: new Date(),
        userType: userType,
        userID: userID,
        type: type,
        message: message,
      };

      try {
        this.loading = true;
        let res2 = await addDoc(collection(db, "alerts"), notification);
        this.loading = false;
      } catch (error) {
        console.log("Error: ", error);
        this.loading = false;
      }
    },
    async downloadInvoice() {
      try {
        this.generatingInvoice = true;

        // Create a new PDF document
        const pdfDoc = await PDFDocument.create();
        let currentPage = pdfDoc.addPage([595, 842]); // A4 size
        const { width, height } = currentPage.getSize();

        // Load fonts
        const helveticaFont = await pdfDoc.embedFont(StandardFonts.Helvetica);
        const helveticaBoldFont = await pdfDoc.embedFont(
          StandardFonts.HelveticaBold
        );
        const helveticaObliqueFont = await pdfDoc.embedFont(
          StandardFonts.HelveticaOblique
        );

        // Colors - using app's color scheme
        const primaryColor = rgb(67 / 255, 144 / 255, 192 / 255); // #4390c0
        const secondaryColor = rgb(224 / 255, 34 / 255, 209 / 255); // #e022d1
        const darkGray = rgb(44 / 255, 62 / 255, 80 / 255); // #2c3e50
        const lightGray = rgb(108 / 255, 117 / 255, 125 / 255); // #6c757d
        const white = rgb(1, 1, 1);
        const lightBg = rgb(0.95, 0.95, 0.95);
        const black = rgb(0, 0, 0);

        // Helper function to draw watermark on a page
        const drawWatermark = (page) => {
          if (logoImage) {
            const watermarkDims = logoImage.scale(0.6); // Large watermark size
            const centerX = width / 2;
            const centerY = height / 2;

            // Draw watermark centered on page
            // Use graphics state for opacity if available, otherwise just draw it
            // The watermark will appear behind content since it's drawn first
            try {
              page.drawImage(logoImage, {
                x: centerX - watermarkDims.width / 2,
                y: centerY - watermarkDims.height / 2,
                width: watermarkDims.width,
                height: watermarkDims.height,
              });

              // Draw a semi-transparent white overlay to lighten the watermark
              // This creates a faded watermark effect
              page.drawRectangle({
                x: centerX - watermarkDims.width / 2,
                y: centerY - watermarkDims.height / 2,
                width: watermarkDims.width,
                height: watermarkDims.height,
                color: white,
                opacity: 0.85, // Light overlay to fade the watermark
              });
            } catch (error) {
              // Fallback: just draw the image without overlay
              page.drawImage(logoImage, {
                x: centerX - watermarkDims.width / 2,
                y: centerY - watermarkDims.height / 2,
                width: watermarkDims.width,
                height: watermarkDims.height,
              });
            }
          }
        };

        let yPosition = 0;

        // Helper function to check if we need a new page
        const checkNewPage = (requiredSpace) => {
          if (yPosition < requiredSpace + 50) {
            currentPage = pdfDoc.addPage([595, 842]);
            yPosition = currentPage.getSize().height - 50;
            // Draw watermark on new page
            drawWatermark(currentPage);
            return true;
          }
          return false;
        };

        // Load logo image
        let logoImage = null;
        try {
          const logoResponse = await fetch(this.logo);
          const logoBytes = await logoResponse.arrayBuffer();
          logoImage = await pdfDoc.embedPng(logoBytes);
        } catch (error) {
          console.warn("Could not load logo:", error);
        }

        // Logo - align it with LOTUS LIFE text
        if (logoImage) {
          const logoDims = logoImage.scale(0.07); // Smaller scale (was 0.18)
          // Align logo vertically with LOTUS LIFE text (yPosition - 20 is the text baseline)
          // Adjust for logo height to center-align
          const logoY = 810 - 5 - logoDims.height / 2; // Center align with text
          currentPage.drawImage(logoImage, {
            x: 10,
            y: logoY,
            width: logoDims.width,
            height: logoDims.height,
          });
        }

        // Draw watermark on first page
        drawWatermark(currentPage);

        currentPage.drawText("LOTUS LIFE", {
          x: 90,
          y: 800,
          size: 28,
          font: helveticaBoldFont,
          color: black,
        });

        currentPage.drawText("Consultation Form", {
          x: 90,
          y: 780,
          size: 14,
          font: helveticaBoldFont,
          color: black,
        });

        currentPage.drawRectangle({
          x: 0,
          y: 770,
          width: 1080,
          height: 4,
          color: secondaryColor,
        });

        // Gradient effect bars
        currentPage.drawRectangle({
          x: 0,
          y: 766,
          width: 1080,
          height: 4,
          color: primaryColor,
        });

        let yValue = 745;

        //////////////////////////////////////////////////////////////
        currentPage.drawText("Consultation Date:", {
          x: 25,
          y: yValue,
          size: 12,
          font: helveticaBoldFont,
          color: black,
        });

        currentPage.drawText(this.activity.date, {
          x: 150,
          y: yValue,
          size: 12,
          font: helveticaBoldFont,
          color: primaryColor,
        });

        currentPage.drawText("Consultation Time:", {
          x: 300,
          y: yValue,
          size: 12,
          font: helveticaBoldFont,
          color: black,
        });

        currentPage.drawText(this.activity.startTimeFormatted, {
          x: 425,
          y: yValue,
          size: 12,
          font: helveticaBoldFont,
          color: primaryColor,
        });
        //////////////////////////////////////////////////////////////

        yValue -= 20;

        currentPage.drawText("Consultation Code:", {
          x: 25,
          y: yValue,
          size: 12,
          font: helveticaBoldFont,
          color: black,
        });

        currentPage.drawText(this.activity.consultCode, {
          x: 150,
          y: yValue,
          size: 12,
          font: helveticaBoldFont,
          color: primaryColor,
        });

        //////////////////////////////////////////////////////////////

        yValue -= 20;

        currentPage.drawText("Patient:", {
          x: 25,
          y: yValue,
          size: 12,
          font: helveticaBoldFont,
          color: black,
        });

        let patient;

        if (this.activity.patient.name) {
          patient = this.activity.patient.name;
        } else {
          patient =
            this.activity.patient.firstName +
            " " +
            this.activity.patient.lastName;
        }

        currentPage.drawText(patient, {
          x: 150,
          y: yValue,
          size: 12,
          font: helveticaBoldFont,
          color: primaryColor,
        });
        //////////////////////////////////////////////////////////////

        yValue -= 20;

        currentPage.drawText("Client:", {
          x: 25,
          y: yValue,
          size: 12,
          font: helveticaBoldFont,
          color: black,
        });

        currentPage.drawText(this.activity.clientFullName, {
          x: 150,
          y: yValue,
          size: 12,
          font: helveticaBoldFont,
          color: primaryColor,
        });
        //////////////////////////////////////////////////////////////

        yValue -= 20;

        currentPage.drawText("Client Email:", {
          x: 25,
          y: yValue,
          size: 12,
          font: helveticaBoldFont,
          color: black,
        });

        currentPage.drawText(this.activity.client.email, {
          x: 150,
          y: yValue,
          size: 12,
          font: helveticaBoldFont,
          color: primaryColor,
        });
        //////////////////////////////////////////////////////////////

        yValue -= 20;

        currentPage.drawText("Whats wrong:", {
          x: 25,
          y: yValue,
          size: 12,
          font: helveticaBoldFont,
          color: black,
        });

        currentPage.drawText(this.activity.description.substring(0, 50), {
          x: 150,
          y: yValue,
          size: 12,
          font: helveticaBoldFont,
          color: primaryColor,
        });
        //////////////////////////////////////////////////////////////

        yValue -= 20;

        currentPage.drawText("Doctor:", {
          x: 25,
          y: yValue,
          size: 12,
          font: helveticaBoldFont,
          color: black,
        });

        currentPage.drawText(this.activity.doctorFullName, {
          x: 150,
          y: yValue,
          size: 12,
          font: helveticaBoldFont,
          color: primaryColor,
        });

        //////////////////////////////////////////////////////////////

        yValue -= 20;

        currentPage.drawText("Doctor Email:", {
          x: 25,
          y: yValue,
          size: 12,
          font: helveticaBoldFont,
          color: black,
        });

        currentPage.drawText(this.activity.doctor.email, {
          x: 150,
          y: yValue,
          size: 12,
          font: helveticaBoldFont,
          color: primaryColor,
        });
        //////////////////////////////////////////////////////////////

        yValue -= 20;

        currentPage.drawText("Doctor Number:", {
          x: 25,
          y: yValue,
          size: 12,
          font: helveticaBoldFont,
          color: black,
        });

        currentPage.drawText(this.activity.doctorPhone, {
          x: 150,
          y: yValue,
          size: 12,
          font: helveticaBoldFont,
          color: primaryColor,
        });
        //////////////////////////////////////////////////////////////

        yValue -= 20;

        currentPage.drawText("Doctor Professsion:", {
          x: 25,
          y: yValue,
          size: 12,
          font: helveticaBoldFont,
          color: black,
        });

        currentPage.drawText(this.activity.doctor.profession[0], {
          x: 150,
          y: yValue,
          size: 12,
          font: helveticaBoldFont,
          color: primaryColor,
        });
        //////////////////////////////////////////////////////////////

        yValue -= 20;

        currentPage.drawText("Consult Address:", {
          x: 25,
          y: yValue,
          size: 12,
          font: helveticaBoldFont,
          color: black,
        });

        let address;

        if (this.activity.address) {
          address = this.activity.address.placeName;
        } else {
          address = "Online";
        }

        currentPage.drawText(address, {
          x: 150,
          y: yValue,
          size: 12,
          font: helveticaBoldFont,
          color: primaryColor,
        });
        //////////////////////////////////////////////////////////////

        yValue -= 20;

        currentPage.drawText("Consult Service:", {
          x: 25,
          y: yValue,
          size: 12,
          font: helveticaBoldFont,
          color: black,
        });

        currentPage.drawText(this.activity.consultType, {
          x: 150,
          y: yValue,
          size: 12,
          font: helveticaBoldFont,
          color: primaryColor,
        });
        //////////////////////////////////////////////////////////////

        yValue -= 20;

        currentPage.drawText("Consult Fee:", {
          x: 25,
          y: yValue,
          size: 12,
          font: helveticaBoldFont,
          color: black,
        });

        currentPage.drawText("R" + this.activity.paidAmount, {
          x: 150,
          y: yValue,
          size: 12,
          font: helveticaBoldFont,
          color: primaryColor,
        });
        //////////////////////////////////////////////////////////////

        yValue -= 20;

        currentPage.drawText("Diagnosis:", {
          x: 25,
          y: yValue,
          size: 12,
          font: helveticaBoldFont,
          color: black,
        });

        let diagnosis = this.activity.diagnosis;

        if (!diagnosis) {
          diagnosis = "Not available";
        }

        currentPage.drawText(diagnosis.substring(0, 50), {
          x: 150,
          y: yValue,
          size: 12,
          font: helveticaBoldFont,
          color: primaryColor,
        });
        //////////////////////////////////////////////////////////////

        yValue -= 20;

        currentPage.drawText("Treatment Plan:", {
          x: 25,
          y: yValue,
          size: 12,
          font: helveticaBoldFont,
          color: black,
        });

        let treatmentPlan = this.activity.treatmentPlan;

        if (!treatmentPlan) {
          treatmentPlan = "Not available";
        }

        currentPage.drawText(treatmentPlan.substring(0, 50), {
          x: 150,
          y: yValue,
          size: 12,
          font: helveticaBoldFont,
          color: primaryColor,
        });
        //////////////////////////////////////////////////////////////

        yValue -= 20;

        currentPage.drawText("Medication:", {
          x: 25,
          y: yValue,
          size: 12,
          font: helveticaBoldFont,
          color: black,
        });

        let prescription = this.activity.prescription;

        if (!prescription) {
          prescription = "Not available";
        }

        currentPage.drawText(prescription.substring(0, 50), {
          x: 150,
          y: yValue,
          size: 12,
          font: helveticaBoldFont,
          color: primaryColor,
        });
        //////////////////////////////////////////////////////////////

        currentPage.drawRectangle({
          x: 0,
          y: 425,
          width: 1080,
          height: 4,
          color: secondaryColor,
        });

        // Gradient effect bars
        currentPage.drawRectangle({
          x: 0,
          y: 421,
          width: 1080,
          height: 4,
          color: primaryColor,
        });

        // Logo - align it with LOTUS LIFE text
        if (logoImage) {
          const logoDims = logoImage.scale(0.12); // Smaller scale (was 0.18)
          // Align logo vertically with LOTUS LIFE text (yPosition - 20 is the text baseline)
          // Adjust for logo height to center-align
          const logoY = yPosition - 5 - logoDims.height / 2; // Center align with text
          currentPage.drawImage(logoImage, {
            x: 50,
            y: logoY,
            width: logoDims.width,
            height: logoDims.height,
          });
        }

        // Draw electronic stamp in bottom right corner on first page
        // drawElectronicStamp(currentPage, invoiceNumber);

        // Save the PDF
        const pdfBytes = await pdfDoc.save();
        const blob = new Blob([pdfBytes], { type: "application/pdf" });
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = this.activity.id + ".pdf"; // file name for download
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);

        this.generatingInvoice = false;

        this.promptMessage = "Consult form downloaded successfully!";
        this.promptType = "success";
        this.promptDialog = true;
      } catch (error) {
        console.error("Error generating invoice:", error);
        this.generatingInvoice = false;
        this.promptMessage =
          "Failed to generate consult form. Please try again.";
        this.promptType = "error";
        this.promptDialog = true;
      }
    },
    async submitFollowUp() {
      let valid = this.$refs.followUpForm.validate();

      if (!valid) {
        this.promptMessage = "Please fill out all required fields!";
        this.promptType = "error";
        this.promptDialog = true;
        return;
      }

      try {
        this.activity.followedUp = true;
        this.activity.followedUpBy =
          this.loggedInUser.name + " " + this.loggedInUser.surname;

        let newConsultation = {
          ...this.activity,
          ...this.followUp,
        };

        this.loading = true;
        await setDoc(
          doc(db, "consultations", this.activity.id),
          newConsultation
        );
        this.loading = false;

        this.promptMessage = "Successfully submitted follow up!";
        this.promptType = "success";
        this.promptDialog = true;
      } catch (error) {
        this.loading = false;
        this.promptMessage =
          "Something went wrong while submitting your follow up, please try again!";
        this.promptType = "error";
        this.promptDialog = true;
      }
    },
  },
  computed: {
    providerLabel() {
      const type = this.activity.consultType || "";
      if (this.activity.ambulanceID || type.toLowerCase().includes("ambulance")) {
        return "Ambulance";
      }

      if (this.activity.nurseID || type.toLowerCase().includes("nurse")) {
        return "Nurse";
      }

      return "Provider";
    },
    sortedReports() {
      if (this.activity.reportedIssues && this.activity.reportedIssues[0]) {
        return this.activity.reportedIssues.sort(
          (itemA, itemB) =>
            new Date(itemB.dateCreated.seconds * 1000) -
            new Date(itemA.dateCreated.seconds * 1000)
        );
      } else {
        return [];
      }
    },
    sortedDisputes() {
      if (this.activity.disputes) {
        return this.activity.disputes.sort(
          (a, b) =>
            new Date(a.dateCreated.seconds * 1000) -
            new Date(b.dateCreated.seconds * 1000)
        );
      } else {
        return [];
      }
    },
    loggedInUser() {
      return this.$store.state.user || {};
    },
    role() {
      return this.loggedInUser.adminType;
    },
  },
};
</script>

<style scoped>
.activity-detail-page {
  background: #f6f8fb;
  min-height: calc(100vh - 64px);
  padding: 12px 8px 32px;
}

.activity-toolbar {
  align-items: center;
  background: #ffffff;
  border: 1px solid #e7ecf2;
  border-radius: 8px;
  box-shadow: 0 8px 24px rgba(16, 24, 40, 0.06);
  padding: 12px 16px;
}

.activity-back {
  background: #eef6fb;
  border-radius: 50%;
  padding: 8px;
}

.activity-actions .v-btn {
  min-width: 150px !important;
  text-transform: none;
  letter-spacing: 0;
  font-weight: 700;
}

.activity-content {
  align-items: flex-start;
}

.activity-detail-page .overview-card {
  border: 1px solid #e7ecf2;
  border-radius: 8px !important;
  box-shadow: 0 10px 28px rgba(16, 24, 40, 0.08) !important;
  overflow: hidden;
}

.overview-card-header {
  border-bottom: 1px solid #edf1f5;
  padding-bottom: 14px;
}

.overview-card-header h3 {
  font-size: 18px;
  font-weight: 700 !important;
}

.activity-detail-page .overview-card > .row.my-1 {
  align-items: flex-start;
  border-bottom: 1px solid #edf1f5;
  min-height: 44px;
  padding: 8px 0;
}

.activity-detail-page .overview-card > .row.my-1:last-child {
  border-bottom: 0;
}

.activity-detail-page .overview-card p {
  color: #657385;
  font-size: 13px;
  font-weight: 700;
  line-height: 1.35;
}

.activity-detail-page .overview-card h4 {
  color: #1f2937;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.45;
  overflow-wrap: anywhere;
}

.activity-detail-page .blue-color {
  color: #277aa9 !important;
}

#map-container {
  border-radius: 8px;
  overflow: hidden;
}

@media (max-width: 960px) {
  .activity-actions {
    justify-content: center !important;
  }

  .activity-actions .v-btn {
    margin-bottom: 10px;
    width: 100%;
  }

  .activity-detail-page .overview-card {
    padding: 20px !important;
  }
}
.patientDispute {
  background-color: #e022d1 !important;
}

.adminDispute {
  background-color: black !important;
}

.reportsHolder {
  max-height: 50vh;
  overflow-y: scroll;
}

.chargesHolder {
  max-height: 300px;
  overflow-y: scroll;
}
</style>




